import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IStockIncompleteFormStockItemsSearchResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useStockItemsSearchListAPI = () => {
  const [stockItems, setStockItems] = useState<IStockIncompleteFormStockItemsSearchResponseData[]>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const clearSearchResults = () => {
    setStockItems([]);
  };

  const execute = useCallback(
    async (item: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        if (!item) {
          return;
        }

        const url = `${INVENTORY_MODULE?.STOCK_ITEMS_SEARCH_API?.baseURL}${item}`;

        const response = await axios.get(url, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        const { data } = response;

        if (data.status === true) {
          setStockItems(data.data);
        } else {
          toast.error("Error while fetching items list.");
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          sendCurl(axiosError.config["curlCommand"]);
          captureError(axiosError)
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { stockItems, execute, clearSearchResults };
};
